import { useEffect, useMemo, useState } from "react";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { MapTooltip } from "../../../../widgets/map/mapAddons/mapTooltip";
import { getAllRoadObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import { showMapTooltip } from "../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../../stateManagement/reducers/MapTooltipSlice";
import { getObjectsOnMapPoint } from "../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useMapURLParams } from "../../../../hooks/map/useMapParams";
import { useMapSlice } from "../../../../stateManagement/hooks/useMapSlice";
import { MapName } from "../../../../stateManagement/reducers/maps/actions";
import { buildAdditionalMapFilteredLayer } from "../../../../widgets/map/mapFeatures/utils/buildAdditionalMapFilteredLayer";
import { useMapValidation } from "../../../../hooks/map/useMapValidation";
import { useMapTitle } from "../../../../hooks/map/useMapTitle";

export function MapRoadWorksWithNormativities() {
    const dispatch = useDispatch()
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([])
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown);
    const currentConfig = useMemo(() => getItemWebStorage('currentConfig'), []);
    const { menuAdditionalItems } = currentConfig ?? {};
    const menuItem = menuAdditionalItems.find((menuItem: any) => menuItem?.item?.type === `map.${mapName}`)?.item
    const mapState = useMapSlice(mapName)
    const { appliedFilters, mapFiltersExpressions }: any = mapState ?? {};
    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useMapValidation(menuItem)
    useMapTitle(menuItem, setMapTitle)

    useEffect(() => {
        const layer = buildAdditionalMapFilteredLayer(
            menuItem,
            appliedFilters,
            mapFiltersExpressions,
            currentConfig
        )
        setAdditionalLayers([layer])
    }, [menuItem, appliedFilters, mapFiltersExpressions])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapTooltip type={mapName} />
                <MapWidget
                    additionalLayers={additionalLayers}
                    mapEventHandlers={mapEventHandlers}
                    permanentLayers={permanentLayers}
                    mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null}
                />
                <MapOverlayWidget />
            </div>
        </>
    )
}
